import React, { useState, useEffect } from 'react';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Route, Switch, useLocation } from 'react-router';
import Layout from './components/Layout';
import Admin from './Admin';
import Public from './Public';
import { closeMenus, handleUnhandledRejection } from './Helper'
import { initializeUser } from './API';
import authentication from 'react-azure-b2c';
import LoadingSVG from './icons/Spinner-1s-200px.svg';

import { InteractionRequiredAuthError, BrowserAuthError } from "@azure/msal-browser";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import * as msal from "@azure/msal-browser";
import * as b2c from './b2c/b2c';

function App() {
    const [appJSX, setAppJSX] = useState(<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>);
    const { instance } = useMsal();

    useEffect(() => {
        let msalEventId = '';
        try {
            const loginRequest = { scopes: ["https://login.sd.gov/nr06environmentalfeesapi/read", "https://login.sd.gov/nr06environmentalfeesapi/write"] };
            window.addEventListener('click', closeMenus);
            window.addEventListener('unhandledrejection', handleUnhandledRejection);
            msalEventId = instance.addEventCallback(async (event) => {
                console.log(event);
                if (event.eventType === msal.EventType.LOGIN_FAILURE) {
                    if (event.error && event.error.errorMessage.indexOf("AADB2C90118") > -1) {
                        const config = {
                            tenant: window.env.b2c.tenant,
                            resetPasswordPolicy: window.env.b2c.resetPasswordPolicy,
                        };
                        const forgotPasswordRequest = b2c.getResetPasswordRequest(config);
                        if (event.interactionType === msal.InteractionType.Redirect) {
                            instance.loginRedirect(forgotPasswordRequest);
                        } else if (event.interactionType === msal.InteractionType.Popup) {
                            instance.loginPopup(forgotPasswordRequest).catch(e => {
                                return;
                            });
                        }
                    } else {
                        instance.acquireTokenRedirect(loginRequest);
                    }
                } else if ((event.eventType === msal.EventType.LOGIN_SUCCESS || event.eventType === msal.EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === msal.EventType.SSO_SILENT_SUCCESS) && event.payload.account) {
                    try {
                        if (event.payload.accessToken) {
                            const account = event.payload.account;
                            instance.setActiveAccount(account);

                            window.env.b2cToken = event.payload;
                            window.env.user = await initializeUser();
                            console.log(window.env.user);

                            setAppJSX((
                                <Switch>
                                    <Route path='/admin' component={Admin} />
                                    <Route path='/' component={Public} />
                                </Switch>
                            ));
                        } else {
                            instance.acquireTokenRedirect(loginRequest);
                        }
                    } catch (ex) {
                        setAppJSX((<div>Unable to initialize user... You may try to refresh or try again later.</div>));
                    }
                }
            });

            instance.acquireTokenSilent(loginRequest).then(tokenResponse => {
                // Do something with the tokenResponse
            }).catch(error => {
                if ((error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError) && !instance.interactionInProgress()) {
                    // fallback to interaction when silent call fails
                    return instance.acquireTokenRedirect(loginRequest);
                }
            });
        } catch (ex) {
            setAppJSX((<div>Unable to authenticate user...  You may try to refresh or try again later.</div>));
        } finally {
            return () => {
                instance.removeEventCallback(msalEventId);
                window.removeEventListener('click', closeMenus);
                window.removeEventListener('unhandledRejection', handleUnhandledRejection);
            };
        }
    }, []);

    return (
        <Layout>
            {appJSX}
        </Layout>
    );
}

export default App;